//config.ts
const config = {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000', // Development URL
};

export default config;
